<div class="modal-content border-0">
<div id="itemID">
  <mat-dialog-content id="itemDiv">
    <div class="modal-content border-0">
      <div class="modal-body bg-gris-1 pt-5">
        <h2 class="text-1 fs-4 text-center mb-4">
          {{
            data?.editMode
              ? ('COMMON.Edit Formula Field' | translate)
              : ('COMMON.Add Formula Field' | translate)
          }}
        </h2>
        @if (variablesLoadWarning) {
          <div class="alert alert-warning mx-4 py-2 px-3 small border-0">
            {{ variablesLoadWarning }}
          </div>
        }
        <i
          type="button"
          aria-label="Close"
          (click)="cancel()"
          class="color-4 fs-2 far fa-times-circle position-absolute end-0 top-0 m-3 hover-opacity"
        ></i>

        <form [formGroup]="headerForm" (ngSubmit)="save()" class="formula-builder-form">
          <div class="formula-builder-scroll">
          <!-- Top Configuration Bar -->
          <div class="row g-3 mb-4 config-header p-3 bg-white shadow-sm rounded-lg border">
            <div class="col-md-6">
              <label class="mb-2 text-3 small font-semibold uppercase tracking-wider">
                {{ 'COMMON.Calculation name' | translate }}
                <span class="color-6">*</span>
              </label>
              <input
                matInput
                type="text"
                class="form-control p-2 tracking-normal custom-input"
                formControlName="name"
                [placeholder]="'COMMON.e.g. Total Weight' | translate"
              />
              @if (
                headerForm.get('name')?.invalid &&
                (headerForm.get('name')?.touched || saveAttempted)
              ) {
                <div class="error-msg mt-1">
                  {{ 'COMMON.Calculation name required' | translate }}
                </div>
              } @else if (fieldNameHint) {
                <div class="error-msg mt-1" data-testid="field-name-hint">{{ fieldNameHint }}</div>
              }
            </div>
            <div class="col-md-3">
              <label class="mb-2 text-3 small font-semibold uppercase tracking-wider">
                {{ 'COMMON.Unit Suffix' | translate }}
              </label>
              <input
                matInput
                type="text"
                class="form-control p-2 tracking-normal custom-input"
                formControlName="unit_of_measure"
                maxlength="12"
                [placeholder]="'COMMON.e.g. kg, Sheets' | translate"
              />
              @if (headerForm.get('unit_of_measure')?.invalid) {
                <div class="error-msg mt-1" data-testid="unit-hint">{{ 'COMMON.Unit suffix invalid' | translate }}</div>
              }
            </div>
            <div class="col-md-3">
              <label class="mb-2 text-3 small font-semibold uppercase tracking-wider">
                {{ 'COMMON.Run order label' | translate }}
              </label>
              <!-- A dropdown of positions (Rod, 2026-10-09): nothing to mistype, and each position names
                   the calculations already there. Shown as 1, 2, 3…; stored as 0, 1, 2… as before. -->
              <mat-select
                [panelWidth]="null"
                panelClass="formula-builder-select-panel"
                class="form-select-mat text-1 border-gris tracking-normal polished-select bg-white"
                formControlName="execution_order"
                [compareWith]="sameRunOrder"
                data-testid="run-order-select"
              >
                <mat-select-trigger>{{ runOrderPosition }}</mat-select-trigger>
                @for (opt of runOrderOptions; track opt.value) {
                  <mat-option class="text-1" [value]="opt.value">{{ opt.label }}</mat-option>
                }
              </mat-select>
              <div class="text-3 small mt-1">{{ 'COMMON.Run order hint' | translate }}</div>
              @if (headerForm.get('execution_order')?.invalid) {
                <div class="error-msg mt-1" data-testid="order-hint">{{ 'COMMON.Execution order whole number' | translate }}</div>
              }
            </div>
            <div class="col-12">
              <label class="mb-2 text-3 small font-semibold uppercase tracking-wider">
                {{ 'COMMON.On quote' | translate }}
              </label>
              <mat-select
                                [panelWidth]="null" panelClass="formula-builder-select-panel"
                class="form-select-mat text-1 border-gris tracking-normal polished-select bg-white"
                formControlName="rollup_mode"
              >
                @for (mode of rollupModes; track mode.value) {
                  <mat-option class="text-1" [value]="mode.value">
                    {{ mode.labelKey | translate }}
                  </mat-option>
                }
              </mat-select>
              <div class="text-3 small mt-1">
                {{ 'COMMON.On quote hint' | translate }}
              </div>
            </div>
          </div>

          <div class="logic-mode-toggle mb-4 d-flex gap-0 bg-white border shadow-sm rounded-lg overflow-hidden">
            <button
              type="button"
              class="logic-mode-btn flex-fill"
              [class.active]="isRecipeMode"
              (click)="setLogicMode('recipe')"
            >
              <i class="fas fa-flask me-2"></i>
              {{ 'COMMON.Recipe' | translate }}
            </button>
            <button
              type="button"
              class="logic-mode-btn flex-fill"
              [class.active]="isConditionalMode"
              [class.active-conditional]="isConditionalMode"
              (click)="setLogicMode('conditional')"
            >
              <i class="fas fa-code-branch me-2"></i>
              {{ 'COMMON.Conditional' | translate }}
            </button>
          </div>

          <div class="row g-4 builder-layout">
            <!-- Left Column: Formula Recipe / Conditional -->
            <div class="col-lg-7">
              <div class="builder-card p-4 h-100 shadow-sm border bg-white rounded-xl">
                @if (isRecipeMode) {
                  <div class="d-flex align-items-center mb-4">
                    <div class="section-icon bg-primary-light text-primary rounded-circle me-3">
                      <i class="fas fa-flask"></i>
                    </div>
                    <h3 class="section-title m-0">{{ 'COMMON.Recipe' | translate }}</h3>
                  </div>

                  <div class="steps-scroll-area pr-1">
                    @for (step of steps; track step.step_id; let idx = $index) {
                      <div class="formula-step-container p-3 rounded-lg border bg-gris-1 position-relative">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                          <span class="step-badge px-2 py-1 rounded bg-white border small font-bold">
                            {{ 'COMMON.Formula step' | translate: { n: idx + 1 } }}
                          </span>
                          <div class="d-flex align-items-center">
                            <span class="text-3 small font-semibold italic mr-3">
                              @if (step.type === 'source') {
                                {{ 'COMMON.Start with' | translate }}
                              }
                              @if (step.type === 'operation') {
                                {{ 'COMMON.Then' | translate }}
                              }
                            </span>
                            @if (step.type !== 'source') {
                              <button
                                type="button"
                                class="btn-remove-step text-danger p-0 border-0 bg-transparent hover-scale"
                                (click)="removeStep(idx)"
                                [matTooltip]="'COMMON.Remove step' | translate"
                              >
                                <i class="fas fa-trash-alt"></i>
                              </button>
                            }
                          </div>
                        </div>

                        @if (step.type === 'source') {
                          <div class="row">
                            <div class="col-md-9">
                              <mat-select
                                [panelWidth]="null" panelClass="formula-builder-select-panel"
                                class="form-select-mat text-1 border-gris tracking-normal polished-select bg-white"
                                [value]="step.value"
                                (selectionChange)="updateStep(idx, { value: $event.value })"
                              >
                                @for (v of variables; track v.id) {
                                  <mat-option class="text-1" [value]="v.id">{{ variableLabel(v.id) }}</mat-option>
                                }
                              </mat-select>
                            </div>
                          </div>
                          @if (saveAttempted && !step.value) {
                              <div class="error-msg mt-2">
                                <i class="fas fa-exclamation-circle me-1"></i> {{ 'COMMON.Formula source required' | translate }}
                              </div>
                            }
                        }

                        @if (step.type === 'operation') {
                          <div class="row g-2 align-items-center">
                            <div class="col-md-4">
                              <mat-select
                                [panelWidth]="null" panelClass="formula-builder-select-panel"
                                class="form-select-mat text-1 border-gris tracking-normal polished-select bg-white"
                                [value]="step.operator"
                                (selectionChange)="updateStep(idx, { operator: $event.value })"
                              >
                                @for (op of operators; track op.value) {
                                  <mat-option class="text-1" [value]="op.value">{{ op.labelKey | translate }}</mat-option>
                                }
                              </mat-select>
                            </div>
                            <div class="col-md-5">
                              <mat-select
                                [panelWidth]="null" panelClass="formula-builder-select-panel"
                                class="form-select-mat text-1 border-gris tracking-normal polished-select bg-white"
                                [value]="isCustomOperand(step) ? '__custom__' : step.operand"
                                (selectionChange)="onOperandSourceChange(idx, $event.value)"
                              >
                                <mat-option class="text-1" value="__custom__">
                                  {{ 'COMMON.Formula type a number option' | translate }}
                                </mat-option>
                                @for (v of variables; track v.id) {
                                  <mat-option class="text-1" [value]="v.id">{{ variableLabel(v.id) }}</mat-option>
                                }
                              </mat-select>
                            </div>
                            @if (isCustomOperand(step)) {
                              <div class="col-md-3">
                                <input
                                  type="number"
                                  class="form-control tracking-normal custom-value-input bg-white"
                                  [value]="step.operand ?? ''"
                                  (input)="updateCustomOperand(idx, $any($event.target).value)"
                                  placeholder="0"
                                />
                              </div>
                            }
                          </div>
                          @if (
                            saveAttempted &&
                            (step.operand === undefined || step.operand === null || step.operand === '')
                          ) {
                            <div class="error-msg mt-2">
                              <i class="fas fa-exclamation-circle me-1"></i> {{ 'COMMON.Formula operand required' | translate }}
                            </div>
                          }
                        }
                      </div>
                      <!-- Proximity (Rod, 2026-10-09): a short line ties each step to the next and to
                           the add bar, so the recipe reads top to bottom as one flow. -->
                      <div class="step-connector" aria-hidden="true"></div>
                    }
                    <button type="button" class="add-step-bar tracking-normal" data-testid="add-math-step" (click)="addOperation()">
                      <i class="fas fa-plus-circle me-2"></i>
                      {{ 'COMMON.Add Math Step' | translate }}
                    </button>
                  </div>

                  <div class="d-flex flex-column gap-3 actions-area formatting-gap">
                    <div class="formatting-box p-3 rounded-lg border-dashed border-2">
                      <label class="mb-2 text-3 small font-semibold uppercase tracking-wider d-flex align-items-center">
                        <i class="fas fa-cut me-2"></i> {{ 'COMMON.Add Formatting' | translate }}
                      </label>
                      <mat-select
                                [panelWidth]="null" panelClass="formula-builder-select-panel"
                        class="form-select-mat text-1 border-gris tracking-normal polished-select bg-white"
                        [value]="selectedFormatting"
                        (selectionChange)="onFormattingChange($event.value)"
                      >
                        @for (opt of formattingOptions; track opt.value) {
                          <mat-option class="text-1" [value]="opt.value">{{ opt.labelKey | translate }}</mat-option>
                        }
                      </mat-select>
                    </div>

                    <div class="hint-container mt-2 p-2 rounded bg-light-blue-50 border-primary-light">
                      <p class="text-3 small mb-0 d-flex align-items-start">
                        <i class="fas fa-info-circle me-2 mt-1 text-primary"></i>
                        <span>{{ 'COMMON.Formula variables hint' | translate }}</span>
                      </p>
                    </div>
                  </div>
                } @else {
                  <div class="d-flex align-items-center justify-content-between mb-4">
                    <div class="d-flex align-items-center">
                      <div class="section-icon bg-amber-light text-amber rounded-circle me-3">
                        <i class="fas fa-code-branch"></i>
                      </div>
                      <h3 class="section-title m-0">{{ 'COMMON.Conditional' | translate }}</h3>
                    </div>
                    <button
                      type="button"
                      class="btn-reset-conditional"
                      (click)="resetConditional()"
                      [disabled]="!hasConditionalContent"
                    >
                      <i class="fas fa-undo-alt me-1"></i>
                      {{ 'COMMON.Reset conditions' | translate }}
                    </button>
                  </div>

                  <!-- IF -->
                  <div class="conditional-block if-block mb-4 p-3 rounded-lg border bg-gris-1">
                    <div class="conditional-label mb-3 text-amber small font-bold uppercase tracking-wider">
                      {{ 'COMMON.The Condition' | translate }}
                    </div>
                    <div class="d-flex flex-wrap align-items-center gap-2 mb-2">
                      <span class="conditional-keyword text-3 font-bold italic">{{ 'COMMON.Formula if' | translate }}</span>
                      <mat-select
                                [panelWidth]="null" panelClass="formula-builder-select-panel"
                        class="form-select-mat text-1 border-gris tracking-normal polished-select bg-white conditional-select"
                        [value]="condition.left"
                        (selectionChange)="onConditionLeftChange($event.value)"
                        [placeholder]="'COMMON.Select a field' | translate"
                      >
                        @for (v of variables; track v.id) {
                          <mat-option class="text-1" [value]="v.id">{{ variableLabel(v.id) }}</mat-option>
                        }
                      </mat-select>
                      <mat-select
                                [panelWidth]="null" panelClass="formula-builder-select-panel"
                        class="form-select-mat text-1 border-gris tracking-normal polished-select bg-white conditional-select"
                        [value]="condition.operator"
                        (selectionChange)="updateCondition({ operator: $event.value })"
                      >
                        @for (op of comparisonOperators; track op.value) {
                          <mat-option class="text-1" [value]="op.value">{{ op.labelKey | translate }}</mat-option>
                        }
                      </mat-select>
                      @if (!hideConditionRightFieldDropdown()) {
                        <mat-select
                                [panelWidth]="null" panelClass="formula-builder-select-panel"
                          class="form-select-mat text-1 border-gris tracking-normal polished-select bg-white conditional-select"
                          [value]="conditionRightSelectValue()"
                          (selectionChange)="onConditionRightSourceChange($event.value)"
                        >
                          <mat-option class="text-1" value="__custom__">
                            {{ 'COMMON.Formula type a number option' | translate }}
                          </mat-option>
                          @for (v of variables; track v.id) {
                            <mat-option class="text-1" [value]="v.id">{{ variableLabel(v.id) }}</mat-option>
                          }
                        </mat-select>
                      }
                      @if (isCustomConditionRight() || hideConditionRightFieldDropdown()) {
                        <input
                          type="number"
                          class="form-control tracking-normal custom-value-input bg-white conditional-number"
                          [value]="condition.right ?? ''"
                          (input)="updateCustomConditionRight($any($event.target).value)"
                          [placeholder]="conditionValuePlaceholder()"
                          [attr.min]="isDiscountConditionInput ? 0 : null"
                          [attr.max]="isDiscountConditionInput ? 100 : null"
                          [class.is-invalid]="conditionPercentOutOfRange"
                        />
                      }
                    </div>
                    @if (conditionPercentOutOfRange) {
                      <div class="error-msg mt-2" data-testid="condition-percent-range">
                        <i class="fas fa-exclamation-circle me-1"></i> {{ 'COMMON.Enter 0 to 100' | translate }}
                      </div>
                    }
                    @if (
                      saveAttempted &&
                      (condition.right === undefined || condition.right === null || condition.right === '')
                    ) {
                      <div class="error-msg mt-2">
                        <i class="fas fa-exclamation-circle me-1"></i>
                        {{ 'COMMON.Conditional right required' | translate }}
                      </div>
                    }
                  </div>

                  <!-- THEN -->
                  <div class="conditional-block then-block mb-4 p-3 rounded-lg border bg-gris-1">
                    <div class="conditional-label mb-3 text-success small font-bold uppercase tracking-wider">
                      {{ 'COMMON.If True (THEN)' | translate }}
                    </div>
                    <div class="conditional-action-grid">
                      <span class="conditional-action-label text-3 small font-semibold">{{ 'COMMON.Set Result To' | translate }}</span>
                      <mat-select
                                [panelWidth]="null" panelClass="formula-builder-select-panel"
                        class="form-select-mat text-1 border-gris tracking-normal polished-select bg-white conditional-select"
                        [value]="actionSelectValue('true')"
                        (selectionChange)="onActionSourceChange('true', $event.value)"
                      >
                        <mat-option class="text-1" value="__custom__">
                          {{ 'COMMON.Formula type a number option' | translate }}
                        </mat-option>
                        @for (v of variables; track v.id) {
                          <mat-option class="text-1" [value]="v.id">{{ variableLabel(v.id) }}</mat-option>
                        }
                      </mat-select>
                      @if (isCustomAction('true')) {
                        <input
                          type="number"
                          class="form-control tracking-normal custom-value-input bg-white conditional-number conditional-action-value"
                          [value]="trueAction.value ?? ''"
                          (input)="updateCustomAction('true', $any($event.target).value)"
                          [placeholder]="actionValuePlaceholder('true')"
                          [attr.min]="isDiscountAction('true') ? 0 : null"
                          [attr.max]="isDiscountAction('true') ? 100 : null"
                          [class.is-invalid]="percentOutOfRange('true')"
                        />
                      }
                    </div>
                    @if (percentOutOfRange('true')) {
                      <div class="error-msg mt-2" data-testid="true-percent-range">
                        <i class="fas fa-exclamation-circle me-1"></i> {{ 'COMMON.Enter 0 to 100' | translate }}
                      </div>
                    }
                    @if (isDiscountAction('true') && actionQuoteImpact('true') !== 'discount_percent') {
                      <p class="text-3 small mt-2 mb-0">
                        {{ 'COMMON.Discount percent of unit price hint' | translate }}
                      </p>
                    }
                    @if (showQuoteImpact('true')) {
                      <div class="mt-3">
                        <label class="mb-2 text-3 small font-semibold uppercase tracking-wider d-block">
                          {{ 'COMMON.Quote impact' | translate }}
                        </label>
                        <mat-select
                                [panelWidth]="null" panelClass="formula-builder-select-panel"
                          class="form-select-mat text-1 border-gris tracking-normal polished-select bg-white"
                          [value]="actionQuoteImpact('true')"
                          (selectionChange)="updateActionQuoteImpact('true', $event.value)"
                        >
                          @for (impact of quoteImpactsFor('true'); track impact.value) {
                            <mat-option class="text-1" [value]="impact.value">
                              {{ impact.labelKey | translate }}
                            </mat-option>
                          }
                        </mat-select>
                        <div class="text-3 small mt-1">
                          {{ quoteImpactHintKey(actionQuoteImpact('true')) | translate }}
                        </div>
                      </div>
                    }
                    @if (
                      saveAttempted &&
                      (trueAction.value === undefined || trueAction.value === null || trueAction.value === '')
                    ) {
                      <div class="error-msg mt-2">
                        <i class="fas fa-exclamation-circle me-1"></i>
                        {{ 'COMMON.Conditional then required' | translate }}
                      </div>
                    }
                  </div>

                  <!-- ELSE -->
                  <div class="conditional-block else-block mb-4 p-3 rounded-lg border bg-gris-1">
                    <div class="conditional-label mb-3 text-3 small font-bold uppercase tracking-wider">
                      {{ 'COMMON.If False (ELSE)' | translate }}
                    </div>
                    <div class="conditional-action-grid">
                      <span class="conditional-action-label text-3 small font-semibold">{{ 'COMMON.Otherwise, Set Result To' | translate }}</span>
                      <mat-select
                                [panelWidth]="null" panelClass="formula-builder-select-panel"
                        class="form-select-mat text-1 border-gris tracking-normal polished-select bg-white conditional-select"
                        [value]="actionSelectValue('false')"
                        (selectionChange)="onActionSourceChange('false', $event.value)"
                      >
                        <mat-option class="text-1" value="__custom__">
                          {{ 'COMMON.Formula type a number option' | translate }}
                        </mat-option>
                        @for (v of variables; track v.id) {
                          <mat-option class="text-1" [value]="v.id">{{ variableLabel(v.id) }}</mat-option>
                        }
                      </mat-select>
                      @if (isCustomAction('false')) {
                        <input
                          type="number"
                          class="form-control tracking-normal custom-value-input bg-white conditional-number conditional-action-value"
                          [value]="falseAction.value ?? ''"
                          (input)="updateCustomAction('false', $any($event.target).value)"
                          [placeholder]="actionValuePlaceholder('false')"
                          [attr.min]="isDiscountAction('false') ? 0 : null"
                          [attr.max]="isDiscountAction('false') ? 100 : null"
                          [class.is-invalid]="percentOutOfRange('false')"
                        />
                      }
                    </div>
                    @if (percentOutOfRange('false')) {
                      <div class="error-msg mt-2" data-testid="false-percent-range">
                        <i class="fas fa-exclamation-circle me-1"></i> {{ 'COMMON.Enter 0 to 100' | translate }}
                      </div>
                    }
                    @if (isDiscountAction('false') && actionQuoteImpact('false') !== 'discount_percent') {
                      <p class="text-3 small mt-2 mb-0">
                        {{ 'COMMON.Discount percent of unit price hint' | translate }}
                      </p>
                    }
                    @if (showQuoteImpact('false')) {
                      <div class="mt-3">
                        <label class="mb-2 text-3 small font-semibold uppercase tracking-wider d-block">
                          {{ 'COMMON.Quote impact' | translate }}
                        </label>
                        <mat-select
                                [panelWidth]="null" panelClass="formula-builder-select-panel"
                          class="form-select-mat text-1 border-gris tracking-normal polished-select bg-white"
                          [value]="actionQuoteImpact('false')"
                          (selectionChange)="updateActionQuoteImpact('false', $event.value)"
                        >
                          @for (impact of quoteImpactsFor('false'); track impact.value) {
                            <mat-option class="text-1" [value]="impact.value">
                              {{ impact.labelKey | translate }}
                            </mat-option>
                          }
                        </mat-select>
                        <div class="text-3 small mt-1">
                          {{ quoteImpactHintKey(actionQuoteImpact('false')) | translate }}
                        </div>
                      </div>
                    }
                    @if (
                      saveAttempted &&
                      (falseAction.value === undefined || falseAction.value === null || falseAction.value === '')
                    ) {
                      <div class="error-msg mt-2">
                        <i class="fas fa-exclamation-circle me-1"></i>
                        {{ 'COMMON.Conditional else required' | translate }}
                      </div>
                    }
                  </div>

                  <div class="hint-container mt-2 p-2 rounded bg-light-blue-50 border-primary-light">
                    <p class="text-3 small mb-0 d-flex align-items-start">
                      <i class="fas fa-info-circle me-2 mt-1 text-primary"></i>
                      <span>{{ 'COMMON.Conditional formula hint' | translate }}</span>
                    </p>
                  </div>
                }
              </div>
            </div>

            <!-- Right Column: Test Bench -->
            <div class="col-lg-5">
              <div class="builder-card p-4 test-bench-card shadow-sm border bg-white rounded-xl sticky-test-bench">
                <div class="d-flex align-items-center mb-2">
                  <div class="section-icon bg-success-light text-success rounded-circle me-3">
                    <i class="fas fa-vial"></i>
                  </div>
                  <h3 class="section-title m-0">{{ 'COMMON.Test Bench' | translate }}</h3>
                </div>
                <p class="text-3 small mb-4">{{ 'COMMON.Real-time validation of your logic' | translate }}</p>

                <div class="test-inputs-area mb-4">
                  @if (!usedVariables.length) {
                    <div class="text-center py-5 bg-gris-1 rounded-lg border-dashed">
                      <i class="fas fa-layer-group fs-2 opacity-20 mb-3 d-block"></i>
                      <p class="text-3 small mb-0 px-3">
                        {{ 'COMMON.No variables currently used in the formula.' | translate }}
                      </p>
                    </div>
                  } @else {
                    <div class="row g-3">
                      @for (varId of usedVariables; track varId) {
                        <div class="col-12">
                          <div class="test-input-wrapper">
                            <label class="mb-1 text-3 small font-semibold d-flex justify-content-between">
                              {{ variableLabel(varId) }}
                              <span class="text-muted font-normal x-small">{{ 'COMMON.Formula input' | translate }}</span>
                            </label>
                            <div class="input-group">
                              <span class="input-group-text bg-white border-end-0 text-muted">
                                <i class="fas fa-terminal x-small"></i>
                              </span>
                              <input
                                matInput
                                type="number"
                                class="form-control p-2 test-input border-start-0"
                                [value]="testValueDisplay(varId)"
                                (input)="onTestValueChange(varId, $any($event.target).value)"
                                [attr.min]="testInputMin(varId)"
                                [attr.max]="testInputMax(varId)"
                              />
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                  <!-- Numbers typed into the formula: shown so every value is visible, never editable here. -->
                  @if (fixedNumbers.length) {
                    <div class="row g-3 mt-0" data-testid="fixed-numbers">
                      @for (fixed of fixedNumbers; track $index) {
                        <div class="col-12">
                          <div class="test-input-wrapper fixed-number-row">
                            <label class="mb-1 text-3 small font-semibold d-flex justify-content-between">
                              {{ fixed.label }}
                              <span class="text-muted font-normal x-small">{{ 'COMMON.Formula fixed number' | translate }}</span>
                            </label>
                            <div class="input-group">
                              <span class="input-group-text bg-gris-1 border-end-0 text-muted">
                                <i class="fas fa-lock x-small"></i>
                              </span>
                              <input
                                type="text"
                                class="form-control p-2 test-input border-start-0 bg-gris-1 text-muted"
                                [value]="fixed.value"
                                readonly
                                tabindex="-1"
                                [attr.aria-label]="fixed.label"
                              />
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>

                <!-- Result Card -->
                <div class="result-display-card p-4 rounded-xl shadow-lg position-relative overflow-hidden" [class.bg-danger-light]="!!result.error && !resultIncomplete" [class.bg-primary-dark]="!result.error || resultIncomplete">
                  <div class="result-pattern"></div>
                  <div class="d-flex justify-content-between align-items-center mb-2 position-relative z-1">
                    <span class="text-white opacity-70 small font-bold uppercase tracking-widest">
                      {{ headerForm.value.name || ('COMMON.Calculation name' | translate) }}
                    </span>
                  </div>

                  <div class="d-flex align-items-baseline position-relative z-1">
                    @if (resultIncomplete) {
                      <span class="text-white opacity-70 fs-5" data-testid="result-incomplete">
                        {{ 'COMMON.Finish the steps to see the result' | translate }}
                      </span>
                    } @else if (result.error) {
                      <div class="text-white d-flex align-items-center">
                        <i class="fas fa-exclamation-triangle me-2"></i>
                        <span class="font-bold fs-3">{{ 'COMMON.Calculation error' | translate }}</span>
                      </div>
                    } @else {
                      <span class="result-value text-white fs-1 font-bold">{{ result.result }}</span>
                      <span class="result-unit text-white opacity-70 fs-4 ms-2">{{ headerForm.value.unit_of_measure }}</span>
                    }
                  </div>

                  @if (result.error && !resultIncomplete) {
                    <div class="error-detail mt-2 p-2 rounded bg-white-transparent text-white small position-relative z-1">
                      {{ messageText(result.error) }}
                    </div>
                  }
                  @if (result.warning && !result.error) {
                    <div class="warning-detail mt-2 d-flex align-items-center text-white small position-relative z-1">
                      <i class="fas fa-exclamation-circle me-2"></i>
                      {{ messageText(result.warning) }}
                    </div>
                  }
                </div>

                <!-- The formula in plain words + with the test numbers (Rod, 2026-10-09). -->
                @if (plainFormula; as pf) {
                  <div class="plain-formula mt-3 p-3 rounded-lg border bg-gris-1" data-testid="plain-formula">
                    <div class="plain-formula-words">{{ pf.words }}</div>
                    <div class="plain-formula-numbers mt-1">{{ pf.numbers }}</div>
                  </div>
                }
              </div>
            </div>
          </div>
          </div>

          <!-- Buttons stay visible even when recipe has many steps -->
          <div class="formula-builder-actions d-flex justify-content-center gap-3">
            @if (saveError) {
              <div class="alert alert-danger mb-0 w-100 max-w-500 text-center py-2 px-3 small border-0 shadow-sm d-flex align-items-center justify-content-center">
                <i class="fas fa-exclamation-triangle me-2"></i> {{ saveError }}
              </div>
            }
            <button class="btn btn-2 px-5 py-2 font-semibold shadow-sm" type="button" (click)="cancel()">
              {{ 'COMMON.Cancel' | translate }}
            </button>
            <button
              type="submit"
              class="btn btn-1 px-5 py-2 font-semibold shadow-lg hover-scale-sm"
              [disabled]="headerForm.invalid || saving"
            >
              {{ 'COMMON.Formula save' | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </mat-dialog-content>
</div>
</div>
